import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { User } from '@angular/fire/auth';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { environment } from '../../../../environments/environment';

@Component({
	selector: 'app-header',
	standalone: true,
	imports: [CommonModule, RouterModule, MatButtonModule, MatIconModule, MatToolbarModule, MatMenuModule],
	templateUrl: './header.html',
	styleUrl: './header.css'
})

export class Header {
	@Output() toggleSidenavRequested   = new EventEmitter<void>();
	@Output() logoutRequested          = new EventEmitter<void>();
	@Input()  isMobile: boolean        = false;
	@Input()  currentUser: User | null = null;
	readonly isDev                     = !environment.production;

	onToggleSidenavClick(): void {
		this.toggleSidenavRequested.emit();
	}

	onLogoutClick(): void {
		this.logoutRequested.emit();
	}

	get userNameToDisplay(): string {
		return this.currentUser?.displayName || this.currentUser?.email || 'Usuario';
	}
}
